import routerFactory from "libraries/router.library";
import ApplicationPage from "pages/ApplicationPage/ApplicationPage";
import AdminPortalPage from "pages/AdminPortalPage/AdminPortalPage";
import ReviewAndSubmitPage from "pages/ReviewAndSubmitPage/ReviewAndSubmitPage";

const ApplicationRoute = {
label: 'Application Page',
path: '/',
component: ApplicationPage,
}


const ReviewAndSubmitRoute = {
label: 'Review and Submit Page',
path: '/reviewAndSubmit',
component: ReviewAndSubmitPage,

}

const AdminPortalRoute = {
label: 'Admin Portal Page',
path: '/admin',
component: AdminPortalPage,
}   

const routes = [ApplicationRoute, ReviewAndSubmitRoute, AdminPortalRoute];

export default routerFactory(routes);